import { lazy } from 'react';
import Loadable from 'components/Loadable';

const PublicReviews = Loadable(lazy(() => import('../pages/public/Reviews')));
const PublicFeedback = Loadable(lazy(() => import('../pages/public/Feedback')));

const PublicRoutes = {
  path: '/',
  children: [
    {
      path: 'reviews/:id',
      element: <PublicReviews />
    },
    {
      path: 'feedback/:id/:rating',
      element: <PublicFeedback />
    }
  ]
};

export default PublicRoutes;
